import React, { useCallback } from 'react'

import { searchSelectRecentDestination } from 'analytics/eventDefinitions'
import { addGTMEvent } from 'api/googleTagManager'
import SearchMenuList from '../SearchMenu/SearchMenuList'
import SearchMenuListCaption from '../SearchMenu/SearchMenuListCaption'
import SearchMenuListItem from '../SearchMenu/SearchMenuListItem'

interface Props {
  recentSearchItems: App.SearchItem[];
  setValue: (item: App.SearchItem) => void;
}

function RecentLocationsSearch(props: Props) {
  const { recentSearchItems, setValue } = props

  const handleRecentLocationClick = useCallback((
    searchItem: App.SearchItem,
    e: React.MouseEvent<HTMLElement>,
  ) => {
    e.stopPropagation()

    setValue(searchItem)

    if (searchItem.searchType === 'destination') {
      addGTMEvent(searchSelectRecentDestination(searchItem))
    }
  }, [setValue])

  return (<SearchMenuList>
    <SearchMenuListCaption>Places you recently searched</SearchMenuListCaption>

    {recentSearchItems?.map((searchItem) => <SearchMenuListItem
      key={searchItem.value}
      searchItem={searchItem}
      onClick={handleRecentLocationClick}
    />)}
  </SearchMenuList>)
}

export default RecentLocationsSearch
